<div class="px-5 pt-7 pb-10">
  <app-unauth-header></app-unauth-header>
  <div class="w-full md:flex gap-2.5">
    <div class="md:order-2 w-full md:w-1/2">
      <router-outlet/>
    </div>
    <app-news class="md:order-1 w-full md:w-1/2"></app-news>
  </div>
</div>



